function buildFormData(formData, data, parentKey) {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    console.log('buildformdata else');
    console.dir(parentKey);
    console.dir(data);
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
    console.dir(formData);
  }
}

export function jsonToFormData(data) {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
}

export function objectToFormData(obj, namespace) {
  var fd = new FormData();
  var formKey;

  for (var property in obj) {
    /* eslint-disable no-prototype-builtins */
    if (obj.hasOwnProperty(property)) {
      /* eslint-enable no-prototype-builtins */
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, property);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}
